export const Patterns = Object.freeze({
	name: /^[A-Za-zÀ-ÖØ-öø-ÿ ,.'-]+$/,
	email: /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i
});
